import httpService from "./httpService";
import qs from "qs";

export const search = async (params: any) => {
	const { data } = await httpService.get(`/genders/search`, {
		params,
		paramsSerializer: (params) => {
			return qs.stringify(params, { arrayFormat: "repeat" });
		},
	});
	return data;
};

export const categoriesSearch = async (params?: any) => {
	const { data } = await httpService.get(`/gender_categories/search/`, { params });
	return data;
};
